import React, { useEffect, useRef, useState } from "react";
import * as pbi from "powerbi-client";
import * as _ from "lodash";
import { useGetPowerBiEmbedCode } from "../../../Api/azure";
import { POWERBI_REPORT_ID } from "../../../Constants";

export default function PowerBiSitesReport() {
    const [loaded, setLoaded] = useState<boolean>(false);
    const embedComponent = useRef<pbi.Embed>(null);
    const { data: report } = useGetPowerBiEmbedCode(POWERBI_REPORT_ID);

    useEffect(() => {
        if (report === undefined) return;
        if (!loaded) {
            init();
        }
    }, [report]);

    function init() {
        const config: pbi.IEmbedConfiguration = {
            filters: [],
            accessToken: report?.accessToken,
            embedUrl: report?.embedUrl,
            id: report?.id,
            type: "report",
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: false,
                localeSettings: {
                    language: "en",
                    formatLocale: "en",
                },
            },
        } as any;

        const powerbi: pbi.service.Service = new pbi.service.Service(
            pbi.factories.hpmFactory,
            pbi.factories.wpmpFactory,
            pbi.factories.routerFactory
        );

        const reportContainer: any = document.getElementById("reportContainer");
        embedComponent.current = powerbi.embed(reportContainer, config);

        setLoaded(true);
    }

    return (
        <div
            className="PowerBiContainer embed-container"
            id="reportContainer"
        ></div>
    );
}
